import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { useAuth } from "../context/authContext";
import { hasRoleAccess } from "../utils/rolePermissions";

export default function RoleRoute({ allowedRoles }) {
  const { user, role } = useAuth();
  const location = useLocation();

  if (!user) return <Navigate to="/login" replace />;

  const hasAccess = hasRoleAccess(role ?? user.role, allowedRoles);

  if (hasAccess) return <Outlet />;

  // Evita loop infinito: / -> sin acceso -> / -> ...
  if (location.pathname === "/") {
    return (
      <Box sx={{ py: 6, px: 3, textAlign: "center" }}>
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
          Acceso restringido
        </Typography>
        <Typography color="text.secondary">
          Tu rol ({role || user.role || "desconocido"}) no tiene permiso para ver el resumen.
          Contacta al administrador si crees que es un error.
        </Typography>
      </Box>
    );
  }

  return <Navigate to="/" replace />;
}